import { generatePath } from 'react-router-dom';
import { API_ROUTES } from '../consts';
import { StatisticsResponse, MatchEngineStatisticsResponse } from '../@types/statistic';
import { buildRequestParamsByType } from '../utils/request';
import { RequestQueryBuilderParamsEnum } from '../consts/enums';
import request from './index';

export const getSystemStatistics = async (
  daysBack: number,
):Promise<SystemStatisticsResponse> => {
  const { data } = await request.get(API_ROUTES.SYSTEM_STATISTICS, { params: { daysBack: daysBack.toString() } });

  return data;
};

export const getStatisticsByPosition = async (
  positionId?: string, accountId?: string,
): Promise<StatisticsResponse> => {
  const url = generatePath(API_ROUTES.STATISTICS_BY_POSITION, { accountId, positionId });
  const { data } = await request.get(url);

  return data;
};

export const getMatchEngineStatistics = async (
  accountId: string,
  positionId: string,
  query: ApiQuery,
):Promise<MatchEngineStatisticsResponse> => {
  const url = generatePath(API_ROUTES.MATCH_ENGINE_STATISTICS, { accountId, positionId });
  const { data } = await request.get(url, {
    params: {
      ...buildRequestParamsByType(query.in || {}, RequestQueryBuilderParamsEnum.in),
    },
  });

  return data;
};
